import { LabelledEntity } from 'shared/types/commonView';
import { createCreatedByOperator } from './createdByOperators';
import {
  CompanyFilterInput,
  ExecutedByCompanyFilterInput,
  SubcontractorCompanyFilterInput,
} from '../companyFilter';
import { ContractFilterInput } from '../contractFilter';
import { LevelFilterInput } from '../levelFilter';
import { ProcessFilterInput } from '../processFilter';
import { SiteFilterInput } from '../siteFilter';
import { StatusFilterInput } from '../statusFilter';
import { WorkflowFilterInput } from '../workflowFilter';
import {
  AssigneeUserFilterInput,
  CreatedByUserFilterInput,
  ExecutorUserFilterInput,
  IssueCreatedByUserFilterInput,
  ModifiedByUserFilterInput,
  SupervisorUserFilterInput,
} from '../userFilter';
import {
  createContainsDirectEntityOperator,
  createContainsOperator,
} from './operatorFactories';

interface PrimaryDataRow {
  primaryData?: {
    assignee?: LabelledEntity | null;
    executor?: LabelledEntity | null;
  };
}

interface ExtendedDataUserRow {
  extendedData?: {
    supervisor?: LabelledEntity | null;
  };
}

interface ModifiedByRow {
  modifiedBy?: LabelledEntity | null;
}

export const getLevelOperator = createContainsOperator(LevelFilterInput);

export const getSiteOperator = createContainsOperator(SiteFilterInput);

export const getCompanyOperator = createContainsOperator(CompanyFilterInput);

export const getSubcontractorCompanyOperator = createContainsOperator(
  SubcontractorCompanyFilterInput
);

export const getExecutedByCompanyOperator = createContainsOperator(
  ExecutedByCompanyFilterInput
);

export const getContractNumberOperator = createContainsOperator(
  ContractFilterInput
);

export const getProcessOperator = createContainsOperator(ProcessFilterInput);

export const getWorkflowOperator = createContainsOperator(WorkflowFilterInput);

export const getStatusOperator = createContainsOperator(StatusFilterInput);

export const getUserOperator = createContainsDirectEntityOperator(
  AssigneeUserFilterInput,
  (row: PrimaryDataRow) => row.primaryData?.assignee ?? null
);

export const getExecutorOperator = createContainsDirectEntityOperator(
  ExecutorUserFilterInput,
  (row: PrimaryDataRow) => row.primaryData?.executor ?? null
);

export const getCreatedByOperator = createCreatedByOperator(
  CreatedByUserFilterInput
);

export const getIssueCreatedByOperator = createCreatedByOperator(
  IssueCreatedByUserFilterInput
);

export const getModifiedByOperator = createContainsDirectEntityOperator(
  ModifiedByUserFilterInput,
  (row: ModifiedByRow) => row.modifiedBy ?? null
);

export const getSupervisorOperator = createContainsDirectEntityOperator(
  SupervisorUserFilterInput,
  (row: ExtendedDataUserRow) => row.extendedData?.supervisor ?? null
);
